import { Base64 } from "js-base64";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { toast } from "react-toastify";
// export const base_url = "https://insugo.vensframe.com/";
// export const base_url = "https://digi.insugo.in/";
// export const base_url = "https://digi.pmpframe.com/";
export const base_url = "https://security.insugo.in/";

const loggedInUser = localStorage.getItem("userId");
const user = JSON.parse(loggedInUser);

export const ID = user !== null ? user?.userid : "";

export const getToken = () => {
  const stored = localStorage.getItem("userId");
  const parsed = stored ? JSON.parse(stored) : null;
  return parsed?.token || "";
};

export const authHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Clears the stored session and sends the user back to the login screen, after
// showing a popup so the user knows why. Guarded so concurrent 401s don't
// trigger multiple toasts/redirects.
let loggingOut = false;
export const logout = (message = "Your session has expired. Please log in again.") => {
  if (loggingOut) return;
  loggingOut = true;
  toast.error(message);
  localStorage.removeItem("userId");
  // Delay the redirect so the popup is visible before the page navigates.
  setTimeout(() => {
    window.location.href = "/login";
  }, 1800);
};

// Wrapper around fetch for authenticated calls. adminlogin.php authorizes via
// an `auth_token` cookie (set at login), so we must send credentials on every
// request for the browser to attach that cookie cross-origin. We also send the
// JWT as a standard `Authorization: Bearer <token>` header.
// If the backend reports an expired/invalid token, we auto-logout.
export const authFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    credentials: "include",
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  });

  // Detect an expired/invalid token and force a logout. The API may signal this
  // via the HTTP status or a `{ success: false, status: 401 }` JSON body.
  try {
    const data = await response.clone().json();
    const unauthorized =
      response.status === 401 ||
      data?.status === 401 ||
      /expired token|unauthor/i.test(data?.message || "");
    if (unauthorized) {
      logout(
        /expired token/i.test(data?.message || "")
          ? "Your session has expired. Please log in again."
          : data?.message || "Session expired. Please log in again."
      );
    }
  } catch (e) {
    // Non-JSON response (e.g. a file/export) — nothing to inspect.
  }

  return response;
};

export const isValidEmail = /\S+@\S+\.\S+/;
// export const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const exportPDF = ({
  table_headers,
  table_data,
  tableName,
  fileName,
}) => {
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "portrait"; // portrait or landscape

  const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);

  doc.setFontSize(15);

  const title = { tableName };
  //   const title = "Insugo";
  //   const headers = [
  //     ["S.No.", "Name", "Email", "Mobile", "Platform", "Policies", "Document"],
  //   ];
  const headers = [table_headers];
  const data = table_data;
  //   const data = users_list.map((elt, i) => [
  //     i + initialValue,
  //     elt.Name,
  //     elt.Email,
  //     elt.mobile,
  //     elt.platform,
  //     elt.totalpolicies,
  //     elt.totaldocument,
  //   ]);

  let content = {
    startY: 50,
    head: headers,
    body: data,
  };

  doc.text(tableName, marginLeft, 40);
  doc.autoTable(content);
  doc.save(`${fileName}.pdf`);
};

export const encryptData = (data) => {
  const randomChars = Array.from(
    { length: 2 },
    () => String.fromCharCode(Math.floor(Math.random() * 26) + 97) // Generates random lowercase letters
  ).join("");
  const randomChars1 = Array.from(
    { length: 2 },
    () => String.fromCharCode(Math.floor(Math.random() * 26) + 97) // Generates random lowercase letters
  ).join("");
  const encryptedData = Base64.encode(data);

  return randomChars + encryptedData + randomChars1;
};
export const decryptData = (str = "") => {
  if (str.length < 4) {
    // The string is too short to remove 2 characters from both the start and end.
    return str;
  }

  // Remove 2 characters from the start and end
  const result = str.substring(2, str.length - 2);
  const decryptedData = Base64.decode(result);
  return decryptedData;
};
